import { render, staticRenderFns } from "./App.vue?vue&type=template&id=555abbe0&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555abbe0')) {
      api.createRecord('555abbe0', component.options)
    } else {
      api.reload('555abbe0', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=555abbe0&", function () {
      api.rerender('555abbe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/App/App.vue"
export default component.exports